import React, { useEffect } from "react";
import GaugeChart from "react-gauge-chart";

const FarmerReportGaugeChart = ({ farmerDataCl, chartName }) => {
  const per = farmerDataCl / 100;
  const defaultper = 0;
  const chartId = `gauge-${chartName}-${farmerDataCl}`;

  // Re-trigger resize when value changes
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     window.dispatchEvent(new Event("resize"));
  //   }, 100);
  //   return () => clearTimeout(timer);
  // }, [farmerDataCl]);

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (!document.hidden) {
  //       setTimeout(() => {
  //         window.dispatchEvent(new Event("resize"));
  //       }, 100);
  //     }
  //   };
  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  // }, []);

  return (
    <React.Fragment>
      <GaugeChart
        id={chartId}
        key={farmerDataCl}
        nrOfLevels={30}
        colors={["#EA4228", "#F5CD19", "#5BE12C"]}
        arcWidth={0.3}
        percent={farmerDataCl ? per : defaultper}
        textColor={"black"}
        className="my-3"
        animate={false}
      />
      <h5 className="text-center steelblue">
        {chartName} : {farmerDataCl ? farmerDataCl?.toFixed(2) : farmerDataCl}
      </h5>
      <div className="text-center my-2">
        <div
          className="d-flex flex-wrap justify-content-between align-items-center bg-white rounded px-2"
          style={{ fontSize: "0.75rem" }}
        >
          <div
            className="d-flex align-items-center me-1"
            title="ACS < 50: Poor"
          >
            <i
              className="mdi mdi-circle text-danger me-1"
              style={{ fontSize: "0.6rem" }}
            ></i>
            <span className="text-muted me-1">&lt; 50:</span>
            <strong className="text-danger">Poor</strong>
          </div>

          <div
            className="d-flex align-items-center mx-1"
            title="ACS 50–60: Normal"
          >
            <i
              className="mdi mdi-circle me-1"
              style={{ color: "#e7b629", fontSize: "0.6rem" }}
            ></i>
            <span className="text-muted me-1">50–60:</span>
            <strong style={{ color: "#e7b629" }}>Normal</strong>
          </div>

          <div
            className="d-flex align-items-center ms-1"
            title="ACS > 60: Good"
          >
            <i
              className="mdi mdi-circle me-1"
              style={{ fontSize: "0.6rem", color: "#6fe22c" }}
            ></i>
            <span className="text-muted me-1">60-80:</span>
            <strong style={{ color: "#6fe22c" }}>Good</strong>
          </div>

          <div
            className="d-flex align-items-center ms-1"
            title="ACS > 80: Very Good"
          >
            <i
              className="mdi mdi-circle text-success me-1"
              style={{ fontSize: "0.6rem" }}
            ></i>
            <span className="text-muted me-1">&gt; 80:</span>
            <strong className="text-success">Very Good</strong>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FarmerReportGaugeChart;